import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full h-screen flex justify-center items-center p-4"
    >
      <form
        method="POST"
        action="https://getform.io/f/2b1e8d01-0588-47c4-9d0f-84c81a386486"
        className="flex flex-col max-w-[600px] w-full"
      >
        <div className="pb-8">
          <p className="text-4xl font-bold inline border-b-4 border-rose-600">
            Contact
          </p>
          <p className="text-gray-1000 py-5">
            Submit the form below or write me an email
            
          </p>
        </div>
        <input
          className="bg-[#dadde9] p-2"
          type="text"
          placeholder="Name"
          name="name"
        />
        <input
          className="my-4 p-2 bg-[#dadde9]"
          type="email"
          placeholder="Email"
          name="email"
        />
        <textarea
          className="bg-[#dadde9] p-2"
          name="message"
          rows="10"
          placeholder="Message"
        ></textarea>
        <button className=" justify-center mt-10 bg-gradient-to-r from-green-800 to-rose-600 text-white rounded-full border-2 hover:bg-rose-600 hover:border-rose-600 px-4 py-3 my-8 mx-auto flex items-center">
          Let's Connect
        </button>
      </form>
    </div>
  );
};

export default Contact;
